import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
const apiBase = process.env.REACT_APP_API_URL
;
export default function AvatarPicker({ userId, selectedAvatar, onSelect }) {
  const [avatars, setAvatars] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teams, setTeams] = useState([]); // List of teams for dropdown
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Load list of teams once (hardcoded or from backend)
  useEffect(() => {
    async function loadTeams() {
      try {
        const exampleTeams = [
          { slug: "100-thieves", name: "100 Thieves" },
          { slug: "afreeca-freecs", name: "Afreeca Freecs" },
          { slug: "ahq-esports-club", name: "AHQ Esports Club" },
          { slug: "albus-nox", name: "Albus Nox" },
          { slug: "alliance", name: "Alliance" },
          { slug: "bbq-olivers", name: "BBQ Olivers" },
          { slug: "bds", name: "BDS" },
          { slug: "beyond-gaming", name: "Beyond Gaming" },
          { slug: "bilibili-gaming", name: "BLG" },
          { slug: "bnk", name: "BNK FearX" },
          { slug: "bro", name: "OK BRO" },
          { slug: "chiefs-esports-club", name: "Chiefs Esports Club" },
          { slug: "clg", name: "CLG" },
          { slug: "cloud-9", name: "Cloud 9" },
          { slug: "clutch-gaming", name: "Clutch Gaming" },
          { slug: "complexity-gaming", name: "Complexity Gaming" },
          { slug: "ctbc-flying-oyster", name: "CTBC Flying Oyster" },
          { slug: "d-plus", name: "Dplus" },
          { slug: "detonation-focusme", name: "Detonation Focusme" },
          { slug: "dignitas", name: "Dignitas" },
          { slug: "dire-wolves", name: "Dire Wolves" },
          { slug: "drx", name: "DRX" },
          { slug: "echo-fox", name: "Echo Fox" },
          { slug: "edward-gaming", name: "EDG" },
          { slug: "envyus", name: "Envyus" },
          { slug: "evil-geniuses", name: "EG" },
          { slug: "evos", name: "Team Evos" },
          { slug: "fnatic", name: "Fnatic" },
          { slug: "flamengo", name: "Flamengo" },
          { slug: "flash-wolves", name: "Flash Wolves" },
          { slug: "flyquest", name: "Flyquest" },
          { slug: "fun-plus-phoenix", name: "FPX" },
          { slug: "furia", name: "Furia" },
          { slug: "g2-esports", name: "G2 Esports" },
          { slug: "gam-esports", name: "GAM Esports" },
          { slug: "gambit", name: "Gambit" },
          { slug: "geng-esports", name: "GENG Esports" },
          { slug: "giants", name: "Giants" },
          { slug: "golden-guardians", name: "Golden Guardians" },
          { slug: "griffin", name: "Griffin" },
          { slug: "h2k", name: "H2K" },
          { slug: "hanwa-life-esports", name: "Hanwa Life Esports" },
          { slug: "heretics", name: "Heretics" },
          { slug: "immortals", name: "Immortals" },
          { slug: "infinity", name: "Infinity" },
          { slug: "invictus-gaming", name: "IG" },
          { slug: "istanbul-wildcats", name: "Istanbul Wildcats" },
          { slug: "isurus", name: "Isurus" },
          { slug: "jd-gaming", name: "JDG" },
          { slug: "jin-air", name: "Jin-Air" },
          { slug: "kabum-esports", name: "Kabum Esports" },
          { slug: "kc", name: "Karmine Corp" },
          { slug: "keyd", name: "KEYD" },
          { slug: "kt-rolster", name: "KT Rolster" },
          { slug: "lgd-gaming", name: "LGD Gaming" },
          { slug: "lng-esports", name: "LNG Esports" },
          { slug: "loud", name: "Loud" },
          { slug: "mad-lions", name: "Mad Lions" },
          { slug: "mvp", name: "MVP" },
          { slug: "navi", name: "NAVI" },
          { slug: "nip", name: "NIP" },
          { slug: "nrg", name: "NRG" },
          { slug: "ns", name: "Nongshim RedForce" },
          { slug: "omg", name: "OMG" },
          { slug: "optic-gaming", name: "Optic Gaming" },
          { slug: "origen", name: "Origen" },
          { slug: "pain-gaming", name: "Pain Gaming" },
          { slug: "psg-talon", name: "PSG Talon" },
          { slug: "r7", name: "R7" },
          { slug: "red-canids", name: "Red Canids" },
          { slug: "rng", name: "RNG" },
          { slug: "rogue", name: "Rogue" },
          { slug: "rox-tigers", name: "Rox Tigers" },
          { slug: "saigon-buffalo", name: "Saigon Buffalo" },
          { slug: "schalke-04", name: "Schalke 04" },
          { slug: "sk-gaming", name: "SK Gaming" },
          { slug: "splyce", name: "Splyce" },
          { slug: "star-horn-royal-club", name: "Star Horn Royal Club" },
          { slug: "suning-gaming", name: "Suning Gaming" },
          { slug: "super-massive-esports", name: "SuperMassive Esports" },
          { slug: "t1", name: "T1" },
          { slug: "taipei-assassins", name: "Taipei Assassins" },
          { slug: "team-liquid", name: "Team Liquid" },
          { slug: "team-secret", name: "Team Secret" },
          { slug: "team-snake-esports", name: "Team Snake Esports" },
          { slug: "team-vitality", name: "Vitality" },
          { slug: "team-we", name: "WE" },
          { slug: "team-whales", name: "Team Whales" },
          { slug: "top-esports", name: "TOP Esports" },
          { slug: "tsm", name: "TSM" },
          { slug: "unicorns-of-love", name: "Unicorns Of Love" },
          { slug: "vici-gaming", name: "Vici Gaming" },
          { slug: "weibo-gaming", name: "Weibo Gaming" },
        ];
        setTeams(
          exampleTeams.map((team) => ({
            value: team.slug,
            label: team.name,
          }))
        );
      } catch (err) {
        console.error("Failed to load teams:", err);
      }
    }
    loadTeams();
  }, []);

  // Load avatars filtered by selectedTeam only if selectedTeam is not empty
  useEffect(() => {
    if (!selectedTeam) {
      setAvatars([]);
      return;
    }

    async function loadAvatars() {
      setLoading(true);
      setError("");
      try {
        let url;
        if (userId) {
          url = `${apiBase}/api/avatars/user/${userId}`;
        } else {
          url = `${apiBase}/api/avatars/default`;
        }

        url += `?team=${encodeURIComponent(selectedTeam.value)}`;

        const res = await axios.get(url);
        setAvatars(res.data);
      } catch (err) {
        console.error("Error loading avatars:", err);
        setError("Failed to load avatars");
      } finally {
        setLoading(false);
      }
    }

    loadAvatars();
  }, [userId, selectedTeam]);

  return (
    <div>
      {/* Popular avatars for signup */}
      {/* {!userId && (
        <div>
          <div
            style={{
              display: "flex",
              gap: 10,
              background: "#1a232f",
              padding: "10px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "4px",
            }}>
            {["g2-esports/1.png", "t1/3.png", "tsm/2.png"].map((path) => (
              <img
                key={path}
                src={`/avatars/${path}`}
                alt={path}
                style={{
                  width: 50,
                  height: 50,
                  border: selectedAvatar === path ? "2px solid green" : "2px solid transparent",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                className="avatar-select-img"
                onClick={() => onSelect(path)}
              />
            ))}
          </div>
        </div>
      )} */}

      {/* Team selector */}
      <span style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <label htmlFor="team-select" style={{ fontWeight: "500", opacity: "0.3", color: "white", textAlign: "center", fontSize: "14px" }}>
          Search for your favorite teams
        </label>
        <Select
          options={teams}
          value={selectedTeam}
          onChange={(option) => setSelectedTeam(option)}
          placeholder="Select an avatar from your favorite team"
          styles={{
            menu: (provided) => ({
              ...provided,
              overflowY: "auto",
            }),
            option: (provided) => ({
              ...provided,
              color: "black",
            }),
            singleValue: (provided) => ({
              ...provided,
              color: "black",
            }),
          }}
        />

        {/* Loading and error states */}
        {loading && <p>Loading avatars...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </span>
      {/* Avatar grid */}
      {selectedTeam ? (
        <div
          style={{
            maxHeight: 250,
            overflowY: "auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
            background: "rgb(26, 35, 47)",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            boxSizing: "border-box",
            marginTop: "20px",
          }}>
          {avatars.length === 0 && !loading && selectedTeam && <p>No avatars found.</p>}
          {avatars.map((avatar) => (
            <div
              key={avatar.id}
              style={{
                position: "relative",
                width: 50,
                height: 50,
                borderRadius: "6px",
                overflow: "hidden",
                cursor: avatar.locked ? "not-allowed" : "pointer",
                border: selectedAvatar === avatar.image_path ? "2px solid green" : "2px solid transparent",
                opacity: avatar.locked ? 0.5 : 1,
              }}
              onClick={() => {
                if (!avatar.locked) onSelect(avatar.image_path, avatar.id);
              }}>
              <img src={`/avatars/${avatar.image_path}`} alt={avatar.image_filename} className="avatar-select-img" />
              {avatar.locked && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.4)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    fontSize: 14,
                    fontWeight: "bold",
                    textAlign: "center",
                    padding: "0 4px",
                  }}>
                  <div>🔒</div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
